import TreeNodeType from '../../constants/liquidation/TreeNodeType';
import type SensOptions from '../../interfaces/pieces/bordereaux/SensOptions';
import type { TreeRow } from '../../interfaces/pieces/TreeRow';

class TreeRowFilter {
	private bordereauState: number | null = null;

	private sens: SensOptions = 'T';

	constructor(bordereauState: number | null, sens: SensOptions) {
		this.bordereauState = bordereauState;
		this.sens = sens;
	}

	apply(rows: TreeRow[]): TreeRow[] {
		let result = [...rows];

		if (this.bordereauState) {
			result = this.filterByState(result);
		}

		if (this.sens !== 'T') {
			result = this.filterBySens(result);
		}

		return result;
	}

	private filterByState(rows: TreeRow[]): TreeRow[] {
		return rows.reduce<TreeRow[]>((acc, row) => {
			const step = row.bordereau?.state?.step;
			const isEntite = row.nodeType === TreeNodeType.ENTITE;
			const isBordereauOK =
				row.nodeType === TreeNodeType.BORDEREAU && step === this.bordereauState;

			if (!isEntite && !isBordereauOK) return acc;

			acc.push({
				...row,
				children:
					isEntite && row.children
						? this.filterByState(row.children)
						: row.children,
			});

			return acc;
		}, []);
	}

	private filterBySens(rows: TreeRow[]): TreeRow[] {
		return rows.reduce<TreeRow[]>((acc, row) => {
			const isEntite = row.nodeType === TreeNodeType.ENTITE;
			const isBordereau =
				row.nodeType === TreeNodeType.BORDEREAU ||
				row.nodeType === TreeNodeType.CREATE_BORDEREAU;

			const isValid =
				isEntite || (isBordereau && row.bordereau?.sens === this.sens);

			if (!isValid) return acc;

			acc.push({
				...row,
				children:
					isEntite && row.children
						? this.filterBySens(row.children)
						: row.children,
			});

			return acc;
		}, []);
	}
}

export default TreeRowFilter;
